<template>
  <div>
    <div class="body-container border-container" v-if="!onDocumentClick || $route.name == 'participants-portal-profile'">
      <!-- <TelehealthBanner /> -->
      <div class="profile-wrapper select-scroll">
        <div class="profile-page-1">
          <div class="profile-1-wrapper" v-if="$route.name == 'participants-portal-profile'">
            <div class="d-flex flex-column pt-24 pb-12">
              <div class="flex-content p-12" v-if="getParticipantsPortalGlobalElements">
                <div class="text-id">
                  <img width="50px" :src="studyLogoUrl" />
                </div>
              </div>
              <div class="flex-content p-12">
                <div class="text-id" v-translate:STUDY_ID="lang">Study ID</div>
                <span class="text-gray">{{ participant.studyId }}</span>
              </div>
              <div class="flex-content p-12">
                <div class="text-id" v-translate:text_participantId="lang">Participant ID</div>
                <span class="text-gray">{{ participant.userDefinedParticipantId }}</span>
              </div>
              <div class="flex-content p-12">
                <div class="text-id" v-translate:thread_Id_key="lang">Thread ID</div>
                <span class="text-gray">{{ participant.threadParticipantId }}</span>
              </div>
            </div>

            <div class="profile-box">
              <div class="text-center pt-24">
                <button class="btn profile-btn" @click="navigateTab('information')" :class="$route.name == 'participants-portal-profile-information' ? 'participant-portal-active-link' : ''">
                  <span v-translate:personal_info="lang">Personal Information</span>
                  <span>
                    <svg class="mt-4 pull-right" xmlns="http://www.w3.org/2000/svg" width="10" height="15" fill="none" viewBox="0 0 12 20">
                      <path fill="#D8D8D8" fill-rule="evenodd" d="M0 17.86l1.86 1.86 9.859-9.86L1.859 0 0 1.86l8 8-8 8z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="text-center pt-24">
                <button class="btn profile-btn" @click="navigateTab('documents')" :class="$route.name == 'participants-portal-profile-documents' ? 'participant-portal-active-link' : ''">
                  <span v-translate:view_sign_documents="lang">View or Sign Documents</span>
                  <span>
                    <svg class="pull-right mt-4" xmlns="http://www.w3.org/2000/svg" width="10" height="15" fill="none" viewBox="0 0 12 20">
                      <path fill="#D8D8D8" fill-rule="evenodd" d="M0 17.86l1.86 1.86 9.859-9.86L1.859 0 0 1.86l8 8-8 8z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="text-center pt-24">
                <button class="btn profile-btn" @click="navigateTab('settings')" :class="$route.name == 'participants-portal-profile-settings' || $route.name == 'participants-portal-profile-language' || $route.name == 'participants-portal-profile-change-password' ? 'participant-portal-active-link' : ''">
                  <span v-translate:settings_key="lang">Settings</span>
                  <span>
                    <svg class="mt-4 pull-right" xmlns="http://www.w3.org/2000/svg" width="10" height="15" fill="none" viewBox="0 0 12 20">
                      <path fill="#D8D8D8" fill-rule="evenodd" d="M0 17.86l1.86 1.86 9.859-9.86L1.859 0 0 1.86l8 8-8 8z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="text-center pt-24">
                <button class="btn profile-btn" @click="navigateTab('devices')" :class="$route.name == 'participants-portal-profile-devices' || $route.name == 'participants-portal-profile-language' || $route.name == 'participants-portal-profile-change-password' ? 'participant-portal-active-link' : ''">
                  <span v-translate:devices_key="lang">Devices</span>
                  <span>
                    <svg class="pull-right mt-4" xmlns="http://www.w3.org/2000/svg" width="10" height="15" fill="none" viewBox="0 0 12 20">
                      <path fill="#D8D8D8" fill-rule="evenodd" d="M0 17.86l1.86 1.86 9.859-9.86L1.859 0 0 1.86l8 8-8 8z" clip-rule="evenodd" />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="text-center pt-48">
                <button class="btn btn-signOut" data-toggle="modal" data-target="#signOutPermission" v-translate:SIGN_OUT_TITLE="lang">Sign Out</button>
              </div>

              <div class="info-box">
                <div class="text-center pt-27 next">
                  <span class="cursor_pointer btn btn-leave-study mr-10" v-translate:leave_study="lang" data-toggle="modal" data-target="#leave_Study_Modal">{{ "LEAVE_STUDY_TITLE" | translate(lang) }}Leave Study</span>
                  <svg style="vertical-align: middle;" data-toggle="modal" data-target="#leaveStudyModal_info" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path fill="var(--secondary)" fill-rule="evenodd" d="M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zm14.546 0c0 3.615-2.931 6.545-6.546 6.545S1.455 11.615 1.455 8c0-3.615 2.93-6.545 6.545-6.545 3.615 0 6.546 2.93 6.546 6.545z" clip-rule="evenodd" />
                    <path fill="var(--secondary)" fill-rule="evenodd" d="M8 3.636c-.402 0-.727.326-.727.728 0 .401.325.727.727.727.402 0 .727-.326.727-.727 0-.402-.325-.728-.727-.728zm0 2.91c-.402 0-.727.325-.727.727v4.363h1.454V7.273c0-.402-.325-.728-.727-.728z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="privacy-info pt-42 privacy-info-center">
                  <div class="d-flex justify-content-center center-align-section">
                    <div class="nav-item p-0 text-center" v-if="showViewAgreementLink">
                      <a class="nav-link active pl-0" data-toggle="modal" data-target="#viewAgreement" v-translate:VIEW_AGREEMENT_TITLE="lang">View Agreement</a>
                      <!-- <a
                      class="nav-link active pl-0"                    
                      v-translate:VIEW_AGREEMENT_TITLE="lang"
                      @click="navigateTab('agreement')"
                    >View Agreement</a> -->
                    </div>
                    <div class="nav-link active nav-item text-center pl-5" :class="isViewAgreementAvailable || isLicenseAvailable">
                      <a class="pr-5" @click="navigateTab('policy')" v-translate:privacy_policy="lang">Privacy Policy</a>
                    </div>
                    <div v-if="isLicenseAvailable" class="nav-item p-0 text-center">
                      <a class="nav-link active pl-0 pr-0" @click="navigateTab('license')" v-translate:LICENSE_INFORMATION="lang">License Information</a>
                    </div>
                    <div class="nav-link active nav-item text-center pl-5">
                      <a class="pr-5" data-toggle="modal" data-target="#requestAccountDelete" v-translate:label_request_account_deletion="lang">
                        Request Account Deletion
                      </a>
                    </div>
                    <div class="nav-link active nav-item text-center pl-5">
                      <a class="pr-5" data-toggle="modal" data-testid="cookie-preference-btn" @click="openManageCookieModal()">
                        Cookie Preferences
                      </a>
                    </div>
                  </div>
                </div>
                <div class="app-info d-flex justify-content-around pt-42 pb-24">
                  <label class>
                    <span v-translate:app_version_key="lang">App Version</span>
                    {{ web.currentVersion }}
                  </label>
                  <label class>
                    <span v-translate:study_version_key="lang">Study Version</span>
                    {{ participant.studyVersionNumber }}
                  </label>
                  <label class>
                    ©{{ date.getFullYear() }}
                    <span v-translate:THREAD_TITLE="lang">THREAD</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="profile-information-wrapper select-scroll pt-10" v-else>
            <div class="row">
              <div class="col-md-1 col common-back-arrow" v-if="showBack">
                <i class="fa fa-angle-left pl-5" style="font-size:32px;cursor:pointer;" @click="goBack()"></i>
              </div>
              <div class="col-md-12 col-12 p-0" :class="{ 'pb-10 border-bottom col-md-12 text-center': currentRouteName == 'participants-portal-profile-documents' }">
                <router-view></router-view>
              </div>
              <div v-if="showCancel" class="col-md-2 col common-cancel-buttton">
                <h5 @click="$root.$emit('profilepage-cancelclicked')" v-translate:label_cancel="lang">Cancel</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Leave Study -->
      <div class="confirmEmailModel">
        <div class="modal fade" id="leave_Study_Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog m-10" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="verification text-center">
                  <label class="email-id" v-translate:study_withdrawn_request="lang">Are you sure you want to request a withdrawal from the study by notifying your study team?</label>
                </div>
                <div class="row leave_study_btn_grp">
                  <div class="col-6 col-md-6">
                    <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
                  </div>
                  <div class="col-6 col-md-6">
                    <button class="btn leave_study_cntue" data-toggle="modal" data-target="#YesleaveStudyModal" data-dismiss="modal" @click="updateWithdrawStudyFact()" v-translate:YES_TEXT="lang">Yes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Leave Study -->
      <!-- Yes Study -->
      <div class="confirmEmailModel">
        <div class="modal fade" id="YesleaveStudyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="verification">
                  <label class="pl-30 pr-30 pb-30 pt-0" v-translate:STUDY_WITHDRAWN_REQUEST_NOTIFIED="lang">Your study team has been notified of your request to withdraw from the study and will contact you directly.</label>
                </div>
                <div class="row">
                  <div class="col-md-3 offset-md-9 pl-30 pr-30 pb-30 pt-0">
                    <button class="btn leave_study_cntue" data-dismiss="modal" v-translate:OK_BUTTON_TITLE="lang">OK</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--YES Leave Study -->
      <!-- Leave Study info -->
      <div class="confirmEmailModel">
        <div class="modal fade" id="leaveStudyModal_info" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="verification text-left">
                  <div class="confirmEmailTitle pl-30" v-translate:LEAVE_STUDY_TITLE="lang">Leave Study:</div>
                  <label class="pl-30 pr-30 pb-30 pt-0" v-translate:PROFILE_NO_LONGER_WISH_TO_PARTICIPATE="lang">You no longer wish to participate in this study and do not wish any further data be sent or shared with the researchers.</label>
                </div>
                <div class="row">
                  <div class="col-md-3 offset-md-9 pl-30 pr-30 pb-30 pt-0">
                    <button class="btn leave_study_cntue" data-dismiss="modal" v-translate:OK_BUTTON_TITLE="lang">OK</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Leave Study info -->
      <!-- view agreement -->
      <div class="agreementModal">
        <div class="modal fade" id="viewAgreement" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body p-30">
                <div class="text-left" v-if="!showConsentList">
                  <label v-if="participantDocumentList.length > 1" class="text-id agreement" v-translate:view_consent="lang" @click="showDocumentList()">View Agreement</label>
                  <label v-else class="text-id agreement" v-translate:view_consent="lang" @click="showAgreement(participantDocumentList[0].consentId)">View Agreement</label>
                  <br />
                  <label class="text-id agreement" v-translate:download_consent="lang" @click="loadEmailAgreement">Download Agreement </label>
                </div>
                <div v-if="showConsentList">
                  <div class="text-left" v-for="(document, index) in participantDocumentList" :key="index">
                    <label class="text-id agreement" v-translate:dynamic_string="{ key: `${document.consentId}_consentName`, val: lang, html: document.docName }" @click="showAgreement(document.consentId)" data-dismiss="modal">{{ document.docName }}</label>
                    <br />
                  </div>
                </div>
                <div class="row d-flex justify-content-center pt-20">
                  <div class="col-md-6">
                    <button type="button" class="btn leavestudy" data-dismiss="modal" aria-label="Close" @click="closeModal" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- view agreement -->

      <!-- Sign-Out Popup -->
      <div class="confirmEmailModel">
        <div class="modal fade" id="signOutPermission" tabindex="-1" role="dialog" aria-labelledby="clear_all_notify" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="verification text-center mt-15 pt-17 p-2">
                  <label class="email-id" v-translate:sign_out_info="lang">Are you sure you want to sign out of the app? If you do, you will no longer receive reminders or notifications.</label>
                </div>
                <div class="row leave_study_btn_grp">
                  <div class="col-6 col-md-6">
                    <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
                  </div>
                  <div class="col-6 col-md-6">
                    <button class="btn leave_study_cntue" @click.prevent="logout" v-translate:YES_TEXT="lang">Yes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Request Account Deletion-->
      <div class="requestAccountDeleteModal">
        <div class="modal fade" id="requestAccountDelete" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="verification text-center mt-15 pt-17 p-2">
                  <label class="email-id" style="line-height: 1.5;" v-html="accountDeletionMessage"> </label>
                </div>
                <div class="row leave_study_btn_grp">
                  <div class="col-6 col-md-6">
                    <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
                  </div>
                  <div class="col-6 col-md-6">
                    <button class="btn leave_study_cntue" data-dismiss="modal" @click.prevent="deleteAccount(participant)" v-translate:YES_TEXT="lang">Yes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Request Account Deletion -->
    </div>
    <agreement v-if="onDocumentClick && $route.name == 'participants-portal-profile-agreement'" :active="onDocumentClick" :selectedConsentID="selectedConcentID" @backButtonClicked="documentDetailsBackButtonClicked"> </agreement>
    <manageCookiesModal ref="manageCookiesModal" platformType="pweb"></manageCookiesModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { Bitrise, Widget } from "@/components/services/participant-service";
import Agreement from "../../participant-portal/profile/agreement";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import $ from "jquery";
import _ from "lodash";
import FileSaver from "file-saver";
import manageCookiesModal from "@/components/auth/manage-cookies.vue";

export default {
  name: "profile-page",
  data() {
    return {
      widget: new Widget(),
      isViewAgreementAvailable: false,
      isLicenseAvailable: false,
      backButtonClickEvent: null,
      emailAgreement: [],
      date: new Date(),
      participantDocumentList: [],
      eulaAgrementDoc: "THREAD Study Application End User License Agreement",
      showConsentList: false,
      showCancel: false,
      onDocumentClick: false,
      showBack: true,
      bitrise: new Bitrise(),
      selectedConcentID: "",
      // StudyMetaData:"",
      web: {
        id: null,
        studyId: this.$route.params.studyId,
        currentVersion: 1.1
      },
      show: false,
      currentRouteName: ""
    };
  },
  components: {
    Agreement,
    manageCookiesModal
  },
  mounted() {
    this.onDocumentClick = false;
    this.verifyInformationAvailable();
    this.getParticipantDocuments();
    this.$root.$on("SetBackButtonClickEvent", evt => (this.backButtonClickEvent = evt));
    this.$root.$on("SetCancelButtonVisibility", evt => (this.showCancel = evt));
    this.$root.$on("UnsetetBackButtonClickEvent", evt => (this.backButtonClickEvent = null));
    this.$root.$on("SetBackButtonVisibility", evt => (this.showBack = evt));
  },
  computed: {
    ...mapGetters(["participant", "token", "getParticipantsPortalGlobalElements"]),
    view() {
      return this.$route.params.home;
    },
    lang() {
      let selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    studyLogoUrl() {
      return this.getParticipantsPortalGlobalElements.studyLogoUrl;
    },
    studyData() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    isConsentEnabled() {
      return this.studyData && this.studyData.consentEnabled;
    },
    accountDeletionMessage() {
      let message_account_deletion = this.widget.translate("label_message_account_deletion", `Data removal will be processed in accordance with local regulations. Your study site team will contact you to complete this transaction.\n\nWould you like to continue?`).replace("\\n\\n", "\n\n");
      return message_account_deletion.replace("\n\n", "<br><br>").trim();
    },
    showViewAgreementLink() {
      /* Show 'View Agreement' link ONLY when atleast one econsent is configured in the study and atleast one 'Disclaimer' is configured in 'Document & Signature' sub-module of that econsent. */
      return this.isConsentEnabled && this.participantDocumentList.length > 0;
    }
  },
  methods: {
    ...mapActions(["participantLogout"]),
    verifyInformationAvailable() {
      this.isViewAgreementAvailable = this.bitrise.isAggrementAvailable("agreement");
      this.isLicenseAvailable = this.bitrise.isHTMLAvailable("licenseAgreement");
    },
    getParticipantDocuments() {
      this.$api.getParticipantDocuments(this.participant.pid, this.participant.studyId).then(res => {
        let response = res.body;
        this.participantDocumentList = _.filter(response, o => o.docName !== this.eulaAgrementDoc);
      });
    },
    navigateTab(tab) {
      this.show = true;
      this.currentRouteName = "participants-portal-profile-" + tab;
      this.$router.push({
        name: "participants-portal-profile-" + tab,
        params: {}
      });
    },
    showDocumentList() {
      this.showConsentList = true;
    },
    closeModal() {
      this.showConsentList = false;
    },
    documentDetailsBackButtonClicked(event) {
      this.onDocumentClick = false;
      this.$router.push({
        name: "participants-portal-profile",
        params: {}
      });
    },
    showAgreement(consentID) {
      $("#viewAgreement").modal("toggle");
      this.onDocumentClick = true;
      this.showConsentList = false;
      this.selectedConcentID = consentID;
      this.$router.push({
        name: "participants-portal-profile-agreement",
        params: {}
      });
    },
    loadEmailAgreement() {
      let participantDocList = this.participantDocumentList;
      participantDocList.forEach(list => {
        this.emailAgreement.push(list);
      });
      this.downloadFile(this.emailAgreement);
      $("#viewAgreement").modal("toggle");
    },
    downloadFile(dataURL) {
      if (dataURL.length === 1) {
        let oReq = new XMLHttpRequest();
        let URLToPDF = dataURL[0]["preSignedUrl"];
        oReq.open("GET", URLToPDF, true);
        oReq.responseType = "blob";
        oReq.onload = function() {
          let file = new Blob([oReq.response], {
            type: "application/pdf"
          });
          FileSaver.saveAs(file, dataURL[0]["docName"]);
        };
        oReq.send();
      } else {
        let zip = new JSZip();
        let count = 0;
        let zipFilename = "Consent_Doc.zip";
        dataURL.forEach(function(url) {
          JSZipUtils.getBinaryContent(url["preSignedUrl"], function(err, data) {
            if (err) {
              throw err; // or handle the error
            }
            zip.file(url["docName"], data, { binary: true, createFolders: true });
            count++;
            if (count == dataURL.length) {
              zip
                .generateAsync({
                  type: "blob"
                })
                .then(function(blob) {
                  FileSaver.saveAs(blob, zipFilename);
                });
            }
          });
        });
      }
    },
    getWebDetails() {
      let webDataObj = this.bitrise.getJsonData("web");
      if (webDataObj) {
        webDataObj.then(
          response => {
            this.web = response;
          },
          error => {
            let message = this.widget.translate(error.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          }
        );
      }
    },
    logout() {
      this.$api.participantSignout(this.participant.pid, {}).then(response => {
        this.$store.dispatch("participantLogout");
        this.$router.push({ name: "participants-portal-web-login" });
      }).catch(error => {
        let message = "";
        if (error.status === 419) {
          message = this.widget.translate("rss_network_error_session_timeout", "Your session got timed out, Please sign in to continue");
        } else {
          message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
        }
        if (message) this.$toastr.error(message);
        setTimeout(() => {
          this.$store.dispatch("participantLogout");
          this.$router.push({ name: "participants-portal-web-login" });
        }, 3000);
      });
    },
    deleteAccount(participant) {
      let timeZone = moment.tz.guess();
      let time = new Date();
      let timeZoneOffset = time.getTimezoneOffset();
      let abbr = moment.tz.zone(timeZone).abbr(timeZoneOffset);
      let localTimeZone = momentTimeZone(time)
        .locale("en")
        .tz(abbr)
        .format("Z");
      let formatedLocalTime = moment(time)
        .locale("en")
        .format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
      let data = {
        participantId: participant.pid,
        email: participant.email,
        countryId: participant.countryId,
        languageId: participant.languageId,
        siteId: participant.siteId,
        studyId: participant.studyId,
        cancelRequestTimeLocal: formatedLocalTime,
        cancelRequestTimeZone: localTimeZone
      };
      this.$api.requestAccountDelete(this.participant.pid, data).then(
        response => {
          if (response.body) {
            // this.$toastr.success(response.body.message);
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while sending the Request for Account Deletion.");
        }
      );
    },
    updateWithdrawStudyFact() {
      let rawData = { participantLocalTime: this.date };
      this.$api.postWithdrawStudyFact(this.participant.pid, { rawData }).then(response => {
        // this.$toastr.success("Profile updated successfully");
      });
    },
    getStudyAppMetadataFactAccount() {
      this.$api
        .getStudyAppMetadataFact(this.studyId)
        .then(response => {
          this.StudyMetaData = this.response;
        })
        .catch(e => {
          let message = this.widget.translate(e.message, "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    dismissAgreementModal() {
      $("#viewAgreement").modal("toggle");
    },
    goBack(evt) {
      if (this.backButtonClickEvent !== null) {
        this.$root.$emit(this.backButtonClickEvent, evt);
        // this.backButtonClickEvent = null
      } else {
        if (this.$route.name === "participants-portal-profile-settings") {
          this.show = false;
          this.$router.push({name: "participants-portal-profile"})
          return;
        }
        window.history.back();
        setTimeout(() => {
          if (this.$route.name == "participants-portal-profile") {
            this.show = false;
          }
        }, 100);
      }
    },
    openManageCookieModal() {
      this.$refs.manageCookiesModal.show();
    }
  }
};
</script>
<style scoped>
.common-cancel-buttton {
  position: absolute;
  z-index: 1;
  top: 15px !important;
  right: 0px;
}
.common-cancel-buttton h5 {
  cursor: pointer;
}
.btn-leave-study {
  background-color: var(--primary);
  color: #fff;
  border-radius: 15px;
}
.app-info {
  font-size: 13px;
  color: #9b9b9b;
  width: 120%;
  margin-left: -10%;
}
.privacy-info-center {
  text-align: center;
}
.center-align-section {
  display: inline-block !important;
}
</style>
